import React, { useCallback } from 'react'
import { Checkbox as AntCheckbox, Form, Popconfirm, Typography } from 'antd'
import PropTypes from 'prop-types'

import { antFormItemNamePropType } from '../../../common/prop-types'

const Checkbox = ({ name, value, label, onChange, disabled }) => {
  const handleConfirm = useCallback(() => onChange(!value), [onChange, value])

  return (
    <Popconfirm
      disabled={disabled}
      placement="bottom"
      title={
        <Typography.Text>
          {value === true
            ? `If you uncheck this then all location types underneath the category will be moved to additional location types on brands and locations`
            : `If you check this then all location types underneath the category will be deleted from the brands and locations`}
          <br /> Are you sure?
        </Typography.Text>
      }
      onConfirm={handleConfirm}
      okText="Yes"
      cancelText="No"
    >
      <AntCheckbox disabled={disabled} name={name} checked={value}>
        {label}
      </AntCheckbox>
    </Popconfirm>
  )
}

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
}

Checkbox.defaultProps = {
  value: false,
  label: '',
  onChange: undefined,
  disabled: false,
}

const LocationTypeCategoryIsMainCheckbox = ({
  name,
  label,
  rules,
  disabled,
}) => (
  <Form.Item name={name} rules={rules}>
    <Checkbox disabled={disabled} name={name} label={label} />
  </Form.Item>
)

LocationTypeCategoryIsMainCheckbox.propTypes = {
  name: antFormItemNamePropType.isRequired,
  label: PropTypes.string,
  rules: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  ),
  disabled: PropTypes.bool,
}

LocationTypeCategoryIsMainCheckbox.defaultProps = {
  label: '',
  rules: undefined,
  disabled: false,
}

export default LocationTypeCategoryIsMainCheckbox
